import { DetailedHTMLProps, ImgHTMLAttributes } from 'react';
import { Icon, CardImage } from 'react-bootstrap-icons';

import styled, { css } from '@/styled';

export type AspectRatioTypes = '16:9' | '9:16' | '1:1' | '4:3' | '3:2' | '3:1';

interface ImageRatioProps extends DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  aspect?: AspectRatioTypes;
  emptyIcon?: Icon;
}

export const aspectRatioPadding: Record<AspectRatioTypes, string> = {
  '16:9': '56.25%',
  '9:16': '177.78%',
  '1:1': '100%',
  '4:3': '75%',
  '3:2': '66.67%',
  '3:1': '32.81%'
};

const ImageRatio = ({ className, src, emptyIcon: EmptyIcon = CardImage, onClick, ...rest }: ImageRatioProps) => {
  return (
    <div className={className} onClick={onClick}>
      {!src && (
        <div className='image-ratio-empty-icon'>
          <EmptyIcon />
        </div>
      )}

      {src && <img {...rest} src={src} />}
    </div>
  );
};

export default styled(ImageRatio, { label: 'image-ratio' })`
  ${({ theme, aspect, onClick }) => {
    return css`
      position: relative;
      height: 0;
      background: ${theme.variables.imageRatio.background};
      border-radius: ${theme.borderRadius}px;
      padding-bottom: ${aspectRatioPadding[aspect] ?? '100%'};
      overflow: hidden;
      cursor: ${onClick ? 'pointer' : 'inherit'};

      .image-ratio-empty-icon {
        color: ${theme.variables.imageRatio.iconColor};
        font-size: ${theme.space.pxToRem(64)};
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        line-height: 0;
      }

      img {
        border-radius: ${theme.borderRadius}px;
        position: absolute;
        object-fit: contain;
        width: 100%;
        height: 100%;
        z-index: 2;
      }
    `;
  }}
`;
